import React from 'react';
import PropTypes from 'prop-types';

export const ChatPage = ({ children, renderToolbar }) => {
  const nav = renderToolbar()

  return (
    <div className="cu-ui-chat-page">
      {nav && <div className="cu-ui-chat-page__toolbar">{nav}</div>}
      <div className={`cu-ui-chat-page__content ${nav ? '--has-nav' : ''}`}>{children}</div>
    </div>
  )
}

ChatPage.propTypes = {
  children: PropTypes.node,
  renderToolbar: PropTypes.func,
};
